<div class="organization-menu__root">
  <section class="organization-menu">
    <div class="organization-menu__header">
      <img
        class="organization-menu__logo"
        src="../../../assets/img/afas-logo-white.jpg"
        alt="Automated Family Alert System"
      />
      <button mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="organization-menu__content gray-color">
      @if (profile()?.organizations?.length) {
        @for (o of profile()?.organizations; track $index) {
          <div
            class="organization-menu__org"
            [class.organization-menu__org--switchable]="canSwitchOrgs()"
            (click)="onOrganizationSelected(o)"
          >
            <div class="menu-title">{{ o.description }}</div>
          </div>
        }
      }
    </div>
    <mat-action-list class="organization-menu__nav">
      <mat-list-item class="organization-menu__nav-item" (click)="onNavigateToDashboard()">
        <span matListItemTitle class="menu-title">Alert Dashboard</span>
      </mat-list-item>
      <mat-list-item class="organization-menu__nav-item" (click)="onNavigateToAlertRoster()">
        <span matListItemTitle class="menu-title">Alert Roster</span>
      </mat-list-item>
      <mat-list-item class="organization-menu__nav-item" (click)="onNavigateToAlertHistory()">
        <span matListItemTitle class="menu-title">Alert History</span>
      </mat-list-item>
    </mat-action-list>
    <mat-action-list class="organization-menu__admin">
      <mat-list-item class="organization-menu__nav-item" (click)="onNavigateToUserManagement()">
        <span matListItemTitle class="menu-title">User Management</span>
      </mat-list-item>
      <mat-list-item class="organization-menu__nav-item" (click)="onNavigateToConfiguration()">
        <span matListItemTitle class="menu-title">Configuration</span>
      </mat-list-item>
    </mat-action-list>
    <mat-action-list class="organization-menu__contact">
      <mat-list-item class="organization-menu__nav-item" (click)="onContact()">
        <span matListItemTitle class="menu-title">Contact</span>
      </mat-list-item>
    </mat-action-list>
    <div class="organization-menu__footer">
      <button mat-flat-button color="primary" (click)="onLogout()">
        <span>LOGOUT</span>
      </button>
    </div>
  </section>
  <nav class="organization-menu__legal" aria-label="Legal">
    <a href="/assets/legal/terms.html" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
    <span class="organization-menu__legal-separator" aria-hidden="true">·</span>
    <a href="/assets/legal/privacy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
  </nav>
</div>
